module.exports = __webpack_public_path__ + "img/home-siji.264f42c4.png";